import ServicePageTemplate from './ServicePageTemplate';
import { industryProjectInternshipMentorshipConfig } from './trainingPageConfigs';

const InternshipProjectMentorship = () => (
  <ServicePageTemplate {...industryProjectInternshipMentorshipConfig} />
);

export default InternshipProjectMentorship;
